import { useQuery } from "react-query";
import { ParceiroDisponibilidadeItem } from "../typings";
import axios from "infra/http";

function useDisponibilidadeParceiro(
  id: string
) {
  return useQuery(
    `/v1/parceiro/${id}/disponibilidade`,

    async () => {
      const res = await axios.get<ParceiroDisponibilidadeItem[]>(`/v1/parceiro/${id}/disponibilidade`);
      return res.data

    },
    { retry: false }
  );
}

export default useDisponibilidadeParceiro;
